import Vue from 'vue';
import VueSocketIO from 'vue-socket.io';
import axios from 'axios';
import VueAxios from 'vue-axios';

import App from './App.vue';
import router from './router';
import store from './store';

const prodBaseURL = 'https://api.northswing.ca';
const devBaseURL = 'http://localhost:1337';
// const devBaseURL = 'https://api.northswing.ca';
const url = process.env.NODE_ENV === 'production' ? prodBaseURL : devBaseURL;

Vue.config.productionTip = false;

Vue.use(new VueSocketIO({
  debug: true,
  connection: url,
  vuex: {
    store,
    actionPrefix: 'SOCKET_',
    mutationPrefix: 'SOCKET_',
  },
}));

axios.defaults.baseURL = url;
axios.defaults.headers.common.Accept = 'application/json';
axios.defaults.headers.common['Content-Type'] = 'application/json';

Vue.use(VueAxios, axios);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
